// One ceiling for every image viewer (gallery on web and native, and the
// lightbox) so a photo zooms the same wherever it is opened.
export const IMAGE_MAX_ZOOM_SCALE = 10;
